import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import BCMessage from "../ui/BCMessage";

const LOActivities = ({ 
  isGreaterThanMobile, 
  isGreaterThanTablet, 
  isSidebar, 
  isMessage, 
  setIsMessage,
  errorResponse, 
  setErrorResponse
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const history = useHistory();
  const handleError = useCallback(() => {
    setErrorResponse(undefined);
    history.push("/error");
  }, [history]);

  useEffect(() => {
    setIsLoading(false);
  }, [setIsMessage, handleError]);

  return (
    <div className={(isGreaterThanMobile && isGreaterThanTablet && isSidebar) ? "landing-page hide-sidebar" : "landing-page sidebar"}>
      {isLoading ? <Loader active inline="centered" size={"big"} /> : <div>
        <BCMessage
          animation={"fly down"}
          duration={750}
          visible={isMessage}
          transitionOnMount
          styles="full-width"
          onDismiss={() => setIsMessage(false)}
          errorResponse={errorResponse}
        />
        LOActivities
      </div>}
    </div>
  );
};

export default LOActivities;